// @flow

export const generateHeadline = (editRecurringEnabled: boolean): string =>
  editRecurringEnabled
    ? 'Delete recurring or individual'
    : 'Are you sure you want to delete this session?';

export const generateCopy = (editRecurringEnabled: boolean): string =>
  editRecurringEnabled
    ? 'This session is part of a recurring series. Editing this and following will change all future events.'
    : 'Any session notes will also be deleted.';



// WEBPACK FOOTER //
// ./src/containers/sessions/delete-modal/helpers.js